import { render } from "./DeviceInfo.vue?vue&type=template&id=22fefda0&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"

import "./DeviceInfo.vue?vue&type=style&index=0&id=22fefda0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fefda0"]])

export default __exports__